module.exports = __webpack_public_path__ + "img/155.6cedf779.jpg";